import React from 'react';
import Skeleton, { SkeletonTheme } from 'react-loading-skeleton';
import { skeletonWhite, skeletonDarkGrey } from '@PROJECT_ROOT/assets/responsive-frontend/js/variables/colors';

export default function FacilitySkeleton() {
    return (
        <div>
            <div className="row pageContent">
                <div className="col-lg-8 col-12 pageContent--inner">
                    <div className="row m-0 custom-margin">
                        {/* Facility Images Skeleton */}
                        <div className="col-12 facilityImages p-0 custom-padding">
                            <div className="row skeletonImagesContainer">
                                <div className="mainImageSkeletonWrapper">
                                    <Skeleton width={705} />
                                </div>
                                <div className="sideImagesSkeletonWrapper">
                                    <Skeleton width={144} height={0} />
                                    <Skeleton width={144} height={0} />
                                    <Skeleton width={144} height={0} />
                                    <Skeleton width={144} height={0} />
                                    <Skeleton width={144} height={0} />
                                </div>
                            </div>
                        </div>
                        {/* Facility Navigation Skeleton */}
                        <div className="col-12 p-0 mb-3 custom-padding">
                            <Skeleton height={20} />
                        </div>
                        {/* About View Section Skeleton */}
                        <div className="col-12 aboutView whiteBox">
                            {/* Header Skeleton */}
                            <div className="row">
                                <div className="col-md-6 col-12">
                                    <Skeleton height={25} width="70%" />
                                </div>
                                <div className="col-md-6 col-12">
                                    <Skeleton height={25} />
                                </div>
                            </div>
                            {/* Details Section Skeleton */}
                            <div className="row mt-3">
                                <div className="col-md-8">
                                    <Skeleton height={40} />
                                    <div className="aboutView--facilityDetails">
                                        <Skeleton height={20} count={4} />
                                    </div>
                                    <Skeleton height={40} width="100px" style={{ borderRadius: '30px', marginTop: '40px' }} />
                                </div>
                                <div className="col-md-4">
                                    <Skeleton height={200} />
                                    <Skeleton height={20} />
                                    <Skeleton height={20} />
                                </div>
                            </div>
                            {/* Text Content Skeleton */}
                            <Skeleton height={150} />
                        </div>
                    </div>
                </div>
                <div className="col-lg-4 col-12">
                    <div className="checkoutForm d-flex flex-column d-flex skeleton">
                        <div className="checkoutForm--header skeleton">
                            <Skeleton height={50} width="60%" />
                        </div>
                        <div className="checkoutForm--inputs skeleton">
                            <Skeleton height={40} />
                            <Skeleton height={40} />
                        </div>
                        <div className="checkoutForm--body skeleton">
                            <Skeleton height={20} />
                            <Skeleton height={20} />
                        </div>
                        <div className="checkoutForm--footer skeleton">
                            <div className="checkoutForm--total skeleton">
                                <div className="checkoutForm--totalLeft">
                                    <Skeleton height={30} width="60%" />
                                    <Skeleton height={15} width="80%" />
                                </div>
                                <div className="checkoutForm--totalRight skeleton">
                                    <Skeleton height={30} width="60%" />
                                </div>
                            </div>
                            <div className="checkoutForm--desktop--only--skeleton">
                                <Skeleton height={20} />
                            </div>
                            <div className="checkoutForm--mobile--skeleton">
                                <Skeleton height={40} width="50%" style={{ marginTop: '8px' }} />
                            </div>
                            {/* DESC: Disable-ano pravilo jer color ne koristi hardcode boju. */}
                            {/* eslint-disable-next-line react/forbid-component-props */}
                            <SkeletonTheme color={skeletonDarkGrey} highlightColor={skeletonWhite}>
                                <Skeleton height={50} />
                            </SkeletonTheme>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}
